import React, { useEffect, useState } from "react";
import { useIntl, defineMessages } from "react-intl";
import { connect, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { requestBillingActivities, saveBillingSKUInfo } from "../../redux/billing/billingActions";
import { fetchWorkorder, taskComplete, buttonDisabled, billingReasonMandatory } from "../../redux/task/taskActions";
import { uploadAttachments, fileUploadAuditActivity } from "../../redux/attachments/attachmentsActions";
import moment from "moment";
import EditIcon from "../common/icons/editIcon";
import { TextField, CircularProgress, Modal } from "@material-ui/core";
import WorkOrderAction from "./workOrderAction";
import FormSection from "./formSection";
import FormField from "./formFields";
import ActivitiesFormField from "./activitiesFormField";
import AttachmentsField from "./attachmentsField";
import { formatFilesForUpload } from "../common/attachments/attachmentsHelper";
import FollowUpsFormField from "./followUpsField";
import { generateMwaList } from "../../utils/generateMwaList";
import useActivityQuestions from "../activityQuestions/hooks/useActivityQuestions";
import { saveFollowUps } from "../../redux/followUps/followUpsActions";

const messages = defineMessages({
    taskCompleteHeaderTitle: {
        id: "task-complete-form.header-title",
        defaultMessage: "Complete job",
        description: "Complete task form title",
    },
    billingSectionTitle: {
        id: "task-complete-form.billing-section-title",
        defaultMessage: "Billing information",
        description: "Billing information",
    },
    additionalInfoSectionTitle: {
        id: "task-complete-form.additional-comments-section-title",
        defaultMessage: "Additional comments",
        description: "Additional comments section title",
    },
    addBillingActivityCaption: {
        id: "task-complete-form.add-billing-activity-caption",
        defaultMessage: "Add activity for billing",
        description: "Add billing activity caption",
    },
    additionalCommentsCaption: {
        id: "task-complete-form.additional-comments-caption",
        defaultMessage: "Additional comments",
        description: "Additional comments caption",
    },
    additionalCommentsSubtitle: {
        id: "task-complete-form.additional-comments-subtitle-caption",
        defaultMessage: "Please provide any additional details",
        description: "Additional comments subtitle caption",
    },
    addYourCommentsHere: {
        id: "task-complete-form.add-your-comments-here",
        defaultMessage: "Add your comments here",
        description: "Add your comments here label",
    },
    attachmentsSectionTitle: {
        id: "task-complete-form.attachments-section-title",
        defaultMessage: "Attachments",
        description: "Attachments section title",
    },
    completeDate: {
        id: "task-complete-form.date-label",
        defaultMessage: "Date",
        description: "Date label",
    },
    doneButtonText: {
        id: "wo-actions.edit-popup.done",
        defaultMessage: "Done",
        description: "Done Button label",
    },
    followUpsSectionTitle: {
        id: "task-complete-form.follow-ups-section-title",
        defaultMessage: "Follow-ups (if applicable)",
        description: "Follow-ups section title",
    },
    addFollowUpMandatory: {
        id: "admin.work-order-details.follow-up-list.add-follow-up-mandatory",
        defaultMessage: "Follow-ups",
        description: "Add Follow-up title",
    },
});

export const TaskComplete = (props) => {
    const { workOrderNumber } = useParams();
    const intl = useIntl();

    const [data, setData] = useState({
        date: new Date(),
        activities: [],
        additionalComments: null,
    });
    const [submitting, setSubmitting] = useState(false);
    const [uploadFlag, setUploadFlag] = useState(false);
    const [auditActionComplete, setAuditActionComplete] = useState(false);
    const [openDuplicatePopup, setOpenDuplicatePopup] = useState(false);
    var contractNumber = props.workorderData && props.workorderData.FK_contractNumber ? props.workorderData.FK_contractNumber : null;
    var taskId = props.workorderData && props.workorderData.id ? props.workorderData.id : null;
    var completedDate = props.workorderData && props.workorderData.completionDate;
    const [latestFollowUps, setLatestFollowUps] = useState([]);
    const { activityQuestions } = useActivityQuestions();

    const billingReasons = useSelector((state) =>
        state.reasons.partialReasons.has("BillingReason")
            ? state.reasons.partialReasons.get("BillingReason").filter((reason) => reason?.displayReason && reason?.FK_Status_Id === 10)
            : [],
    );

    const selectedReason = useSelector((state) => state.tasks.completionData?.completionCode);

    const getDatafromChild = (data) => {
        setLatestFollowUps(data);
    };

    useEffect(() => {
        if (workOrderNumber) props.fetchWorkorder(workOrderNumber, true);
        setData({
            date: new Date(),
            activities: [],
            additionalComments: null,
        });
    }, [workOrderNumber]);

    useEffect(() => {
        if (contractNumber) props.requestBillingActivities(contractNumber, completedDate);
    }, [contractNumber, completedDate]);

    useEffect(() => {
        if (submitting && (!uploadFlag || auditActionComplete)) {
            for (var key in props.billingSKUInfoResponse) {
                if (props.billingSKUInfoResponse.hasOwnProperty(key)) {
                    setSubmitting(false);
                    if (key !== "failed" && props.isRequestToAddFollowup) {
                        props.taskComplete(props.completionData);
                    }
                    if (key !== "failed") {
                        history.push("/");
                    }
                    return;
                }
            }
        }
    }, [props.billingSKUInfoResponse, auditActionComplete]);

    useEffect(() => {
        if (submitting && (!uploadFlag || auditActionComplete)) {
            for (var key in props.locateInfoResponse) {
                if (props.locateInfoResponse.hasOwnProperty(key)) {
                    setSubmitting(false);
                    if (key !== "failed") {
                        history.push("/");
                    }
                    return;
                }
            }
        }
    }, [props.locateInfoResponse, auditActionComplete]);

    useEffect(() => {
        if (
            uploadFlag &&
            props.fileUploadResponse.length > 0 &&
            typeof props.fileUploadResponse[0] === "object" &&
            props.workOrderAttachments.length > 0
        ) {
            props.fileUploadResponse.map((file, index) => {
                const attachmentID = file.fileDownloadUri.split("/").at(-1);
                const uploadedAttachment = props.workOrderAttachments.filter((attachment) => {
                    return attachment.id === attachmentID;
                })[0];
                const payload = {
                    createdDateTime: uploadedAttachment.createdDateTime,
                    id: uploadedAttachment.id,
                    newFileDescription: "",
                    newFileName: "",
                    newFileType: "",
                    newRelatedJobId: "",
                    newRelatedSourceId: "",
                    oldFileDescription: uploadedAttachment.fileDescription,
                    oldFileName: uploadedAttachment.fileName,
                    oldFileType: uploadedAttachment.fileType,
                    oldRelatedJobId: uploadedAttachment.relatedJobId,
                    oldRelatedSourceId: uploadedAttachment.relatedSourceId,
                    originatingSystem: "CMIS",
                    uploadedBy: props.userProfile.username,
                };
                const closedFun = (payload1, index1) => {
                    setTimeout(() => {
                        props.fileUploadAuditActivity(payload1);
                    }, index1 * 3000);
                };
                closedFun(payload, index);
            });
            setUploadFlag(false);
            setAuditActionComplete(true);
        }
    }, [props.workOrderAttachments]);

    const formateDate = (iDate) => (iDate ? moment(moment(iDate)).utc().format("YYYY-MM-DD HH:mm:00") : "");

    const submit = () => {
        var err = false;
        for (var i = 0; i < data.activities.length; i++) {
            if (!data.activities[i].quantity || parseFloat(data.activities[i].quantity) <= 0) {
                err = true;
                return;
            } else if (data.activities[i].isBillingReasonRequired && (!data.activities[i].billingReason || !data.activities[i].additionalDetails)) {
                err = true;
                return;
            }
            if (err) return;
        }

        setSubmitting(true);
        const followUpDetailsIn = latestFollowUps
            ? latestFollowUps
                  .filter((followUp) => followUp)
                  .map((followUp, index) => {
                      if (followUp.isFollowUpActive) {
                          if (data[`followUps.${index}.comments`]) {
                              followUp.comments = data[`followUps.${index}.comments`];
                          }
                          return {
                              followUpTpyeId: followUp.id,
                              creationDate: formateDate(followUp?.creationDate),
                              comments: followUp.comments || null,
                              id: null,
                              uuid: followUp.uuid,
                              taskId,
                              dueDate: formateDate(followUp?.dueDate),
                              validatedForDoubles: true,
                              duplicateWorkOrdersDTO: followUp?.duplicateWorkOrdersDTO || null,
                              priority: followUp.priority,
                              mwaList: generateMwaList(activityQuestions.questions, followUp, props.followUpReasons),
                          };
                      }
                  })
            : null;
        if (followUpDetailsIn && followUpDetailsIn[0] == undefined) {
            followUpDetailsIn.splice(0, 1);
        }

        var billingSKUInfo = {
            taskId,
            contractNumber,
            additionalComments: data.additionalComments,
            skuList: data.activities.map((activity) => {
                return {
                    // Response body for creation does not use skuID
                    billingActivityCode: activity.productCode,
                    billingActivity_en: activity.productDescription_en,
                    billingActivity_fr: activity.productDescription_fr,
                    // quantity: parseInt(activity.quantity),
                    quantity: parseFloat(activity.quantity).toFixed(2),
                    additionalDetails: activity.additionalDetails ? activity.additionalDetails : null,
                    unitOfMeasure: activity.unitOfMeasure,
                    billingReasonCode: activity?.billingReason?.id || null,
                };
            }),

            userProfile: {
                sub: props.userInfo.sub,
                email_verified: props.userInfo.email_verified,
                adGroup: ["/CmisLabourer"],
                name: props.userInfo.name,
                preferred_username: props.userInfo.preferred_username,
                given_name: props.userInfo.given_name,
                family_name: props.userInfo.family_name,
                employeeNumber: props.technicianInfo.pein,
            },
        };
        if (followUpDetailsIn?.length > 0) {
            const followUpInfo = {
                userProfile: billingSKUInfo.userProfile,
                relatedID: workOrderNumber,
                followUpList: followUpDetailsIn,
            };
            props.saveFollowUps(followUpInfo, workOrderNumber);
        }

        const filesToBeUploaded = formatFilesForUpload(props.filesToUpload, props.workorderData.clickDispatchId, workOrderNumber);
        if (filesToBeUploaded.length > 0) {
            setUploadFlag(true);
        }

        props.saveBillingSKUInfo(billingSKUInfo, workOrderNumber, completedDate, false, filesToBeUploaded);
    };

    var activities = props.billingActivities ? props.billingActivities : [];
    const history = useHistory();

    return (
        <WorkOrderAction title={intl.formatMessage(messages.taskCompleteHeaderTitle)} onSubmit={submit} data={data}>
            <Modal style={{ display: "flex", alignItems: "center", justifyContent: "center" }} open={submitting}>
                <CircularProgress />
            </Modal>
            <FormSection title={intl.formatMessage(messages.billingSectionTitle)}>
                <FormField field="date" label={intl.formatMessage(messages.completeDate)} readonly />
                {activities && (
                    <ActivitiesFormField
                        field="activities"
                        activityOptions={activities}
                        billingReasons={billingReasons}
                        buttonDisabled={props.buttonDisabled}
                        billingReasonMandatory={props.billingReasonMandatory}
                    />
                )}
            </FormSection>

            <FormSection title={intl.formatMessage(messages.additionalInfoSectionTitle)}>
                <FormField
                    field="additionalComments"
                    label={intl.formatMessage(messages.additionalCommentsCaption)}
                    editorProps={{
                        icon: <EditIcon />,
                        btnText: intl.formatMessage(messages.doneButtonText),
                        title: intl.formatMessage(messages.additionalCommentsCaption),
                        editor: (props) => (
                            <TextField
                                id="additional-comments"
                                value={""}
                                placeholder={intl.formatMessage(messages.addYourCommentsHere)}
                                multiline
                                fullWidth
                                rows={4}
                                variant="outlined"
                                InputProps={{
                                    inputProps: { maxLength: 300 },
                                }}
                                {...props}
                            />
                        ),
                    }}
                    newSubTitle={intl.formatMessage(messages.additionalCommentsSubtitle)}
                    divider={false}
                    characterCountEnabled
                />
            </FormSection>

            {process.env.REACT_APP_FEATURE_FILEUPLOAD === "true" && (
                <FormSection title={intl.formatMessage(messages.attachmentsSectionTitle)}>
                    <AttachmentsField workOrderNumber={workOrderNumber} clickDispatchId={props.workorderData.clickDispatchId} />
                </FormSection>
            )}
            {process.env.REACT_APP_FEATURE_CMISR3 === "true" && props.isShowFollowups ? (
                <FormSection
                    title={
                        props.isRequestToAddFollowup
                            ? intl.formatMessage(messages.addFollowUpMandatory)
                            : intl.formatMessage(messages.followUpsSectionTitle)
                    }
                    isMandatory={props.isRequestToAddFollowup}>
                    <FollowUpsFormField
                        field="followUps"
                        workOrderNumber={workOrderNumber}
                        sendData={getDatafromChild}
                        openDuplicatePopup={openDuplicatePopup}
                        setOpenDuplicatePopup={setOpenDuplicatePopup}
                        reasons={props.followUpReasons}
                        selectedReason={selectedReason}
                        isMandatory={props.isRequestToAddFollowup}
                    />
                </FormSection>
            ) : null}
        </WorkOrderAction>
    );
};

const mapStateToProps = (state) => ({
    followUpReasons: state.followUps.followUpReasons ? state.followUps.followUpReasons : [],
    billingActivities: state.billing.activities,
    billingSKUInfoResponse: state.billing.billingSKUInfoResponse,
    locateInfoResponse: state.billing.locateInfoResponse,
    workorderData: state.tasks.workorderData.workorderData,
    filesToUpload: state.attachments.filesToUpload,
    userProfile: state.login.userProfile,
    userInfo: state.login.userInfo,
    technicianInfo: state.login.technicianInfo,
    isRequestToAddFollowup: state.tasks.isRequestToAddFollowup,
    isShowFollowups: state.tasks.isShowFollowups,
    completionData: state.tasks.completionData,
    workOrderAttachments: state.attachments?.workOrderAttachments,
    fileUploadResponse: state.attachments?.fileUploadRes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestBillingActivities,
            fetchWorkorder,
            uploadAttachments,
            saveBillingSKUInfo,
            taskComplete,
            fileUploadAuditActivity,
            buttonDisabled,
            billingReasonMandatory,
            saveFollowUps,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(TaskComplete);
